import React, { useEffect, useState } from 'react';
import AddContactModal from './AddContactModal';
import { addContact, getAllContacts, getContactRoles } from '../../services/MetadataService';

const AddContactModalConnector = ({ ...contactModalProps }) => {
    const [allContacts, setAllContacts] = useState();
    const [contactRoles, setContactRoles] = useState();

    useEffect(() => {
        async function fetchAllContacts() {
            const allContacts = await getAllContacts();
            setAllContacts(allContacts);
        }
        fetchAllContacts();
    }, []);

    useEffect(() => {
        async function fetchContactRoles() {
            const roles = await getContactRoles();
            setContactRoles(roles.map((contactRole) => contactRole.value));
        }
        fetchContactRoles();
    }, []);

    return (
        <AddContactModal
            contactRoles={contactRoles}
            allContacts={allContacts}
            addContact={addContact}
            {...contactModalProps}
        />
    );
};

export default AddContactModalConnector;
